module.exports = "/images/prueba_perfil_comentario_2.png?5ae1e00bfcdc2753cf48c74ad8e374ec";